import { useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import NavBar from '../NavBar/NavBar.js';

const _excluded = ["children"];
function HeaderTopNavBar(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  return /*#__PURE__*/createElement(NavBar, _extends({
    bg: theme.palette.black[80],
    color: theme.palette.common.white
  }, props), children);
}

export { HeaderTopNavBar };
